/**
 * @description: 股东沙龙
 * @author: hwx
*/
<template>
    <div class="vip-salon">
        <div class="salon-list" v-show="showList">
            <h1>股东沙龙</h1>
            <el-form :inline="true" :model="salon_list_form">
                <el-form-item label="门店">
                    <el-select v-model="salon_list_form.shop_id" filterable @change="getSalonType(salon_list_form.shop_id, '1')">
                        <el-option v-for="item in shop_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="活动状态">
                    <el-select v-model="salon_list_form.status" clearable placeholder="请选择状态">
                        <el-option label="未开始" value="-1"></el-option>
                        <el-option label="进行中" value="1"></el-option>
                        <el-option label="已结束" value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item class="pull-right">
                    <el-button type="primary" @click="salonAdd">新增活动</el-button>
                    <el-button type="primary" @click="getSalonTable(1)">查询</el-button>
                </el-form-item>
            </el-form>
            <el-table
                v-loading="loading"
                element-loading-text="努力加载中，请稍后..."
                element-loading-background="rgba(0, 0, 0, 0.6)"
                :data="salon_table">
                <el-table-column prop="shop_name" label="门店"></el-table-column>
                <el-table-column prop="activity_date" label="活动时间"></el-table-column>
                <el-table-column label="报名时间段">
                    <template slot-scope="scope">
                        {{scope.row.sign_up_start_time + '~' + scope.row.sign_up_end_time}}
                    </template>
                </el-table-column>
                <el-table-column prop="name" label="主题内容"></el-table-column>
                <el-table-column prop="status_name" label="活动状态"></el-table-column>
                <el-table-column prop="user_num" label="报名人数"></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <span class="text-blue" @click="salonModify(scope.row)" v-show="scope.row.status != '2'">修改</span>
                        <span class="text-blue" @click="salonDel(scope.row)">删除</span>
                        <span class="text-blue" @click="salonRank(scope.row)" v-show="scope.row.status != '-1'">报名详情</span>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                background
                layout="total, prev, pager, next, jumper"
                :page-size="GLOBAL.PAGESIZE"
                :current-page.sync="salon_page"
                :total="salon_total"
                @current-change="getSalonTable">
            </el-pagination>
        </div>
        <!-- 报名详情 -->
        <div class="salon-rank" v-show="showRank">
            <h1>报名详情</h1>
            <el-form :inline="true">
                <el-form-item label="主题">
                    {{salon_rank_form.name}}
                </el-form-item>
                <el-form-item label="报名人数">
                    {{salon_rank_form.user_num}}
                </el-form-item>
                <el-form-item class="pull-right">
                    <el-button @click="salonBack">返回</el-button>
                </el-form-item>
            </el-form>
            <el-table
                v-loading="loading"
                element-loading-text="努力加载中，请稍后..."
                element-loading-background="rgba(0, 0, 0, 0.6)"
                :data="rank_table">
                <el-table-column prop="vip_level" label="会员等级"></el-table-column>
                <el-table-column prop="vip_level_name" label="等级名称"></el-table-column>
                <el-table-column prop="user_name" label="微信昵称"></el-table-column>
                <el-table-column prop="vip_user_name" label="会员姓名"></el-table-column>
                <el-table-column prop="mobile" label="会员手机号"></el-table-column>
            </el-table>
            <el-pagination
                background
                layout="total, prev, pager, next, jumper"
                :page-size="GLOBAL.PAGESIZE"
                :current-page.sync="rank_page"
                :total="rank_total"
                @current-change="getSalonRank">
            </el-pagination>
        </div>
        <div class="salon-edit" v-show="showEdit">
            <h2>{{salon_edit_tit}}</h2>
            <el-form :model="salon_edit_form" label-width="130px">
                <el-form-item label="门店">
                    <el-select v-model="salon_edit_form.shop_id" filterable @change="getSalonType(this.salon_edit_form.shop_id, '2')">
                        <el-option v-for="item in shop_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="活动主题">
                    <el-input placeholder="请输入活动主题" v-model="salon_edit_form.name"></el-input>
                </el-form-item>
                <el-form-item label="活动日期" class="salon-acd-wrap">
                    <div ref="salon_acd_main">
                        <el-input v-model="salon_edit_form.activity_date" class="el-ellipsis" placeholder="请选择活动日期"></el-input>
                    </div>
                </el-form-item>
                <el-form-item label="报名时间段" class="salon-usedate-wrap">
                    <div ref="salon_usedate_main">
                        <el-input v-model="salon_usedate_txt" class="el-ellipsis" placeholder="请选择报名时间段"></el-input>
                    </div>
                </el-form-item>
                <el-form-item label="活动首页">
                    <img :src="salon_edit_form.home_page_img" id="salonCover" class="salon-cover">
                </el-form-item>
                <el-form-item label="活动详情页">
                    <ul class="clearfix">
                        <li v-for="(item, index) in salon_edit_form.detail_imgs" :key="item.id">
                            <img src="../../assets/images/scrn_del.png" class="salon-imgs-del" @click="salonImgsDel(index)">
                            <img :src="item.src" :id="item.id" class="salon-imgs-item">
                        </li>
                        <li><img src="../../assets/images/adsc_up.png" class="salon-imgs-add" @click="salonImgsAdd"></li>
                    </ul>
                </el-form-item>
                <el-form-item>
                    <el-button @click="salonBack">返回</el-button>
                    <el-button type="primary" @click="salonEdit">确定</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: '',
        data() {
            return {
                showList: true,
                showEdit: false,
                showRank: false,
                shop_list: [],

                salon_list_form: {
                    shop_id: '',
                    status: ''
                },
                salon_page: 1,
				salon_total: 0,
                salon_table: [],

                salon_rank_form: {
                    name: '',
                    user_num: '',
                    shop_id: '',
                    activity_id: ''
                },
                rank_page: 1,
				rank_total: 0,
                rank_table: [],

                salon_edit_id: '',
                salon_edit_tit: '',
                salon_edit_form: {
                    shop_id: '',
                    name: '',
                    activity_date: '',
                    home_page_img: require('../../assets/images/upload_btn.png'),
                    home_page_img_done: false,
                    detail_imgs: []
                },
                salon_usedate_txt: '',
				salon_usedate_start: '',
                salon_usedate_end: '',
				uploader_list: []
            }
        },
        mounted: function() {
            new Promise(resolve => {
                this.getShop(resolve)
            }).then(res => {
                this.salon_list_form.shop_id = this.shop_list[0].id
                this.salon_list_form.status = ''
                this.getSalonTable(1)
                this.initDate()
                this.salonCoverUpload('salonPosterImg')
            })
        },
        methods: {
            // 获取门店数据
			getShop: function(resolve) {
				const _this = this;

				Vue.axios.post('PublicData/api_getShopListByPurview', {
					"header": Vue.request_header,
					"request": {
						"param": {}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						_this.shop_list = res.data.response.result;
                        _this.shop_list.shift();
                        resolve()
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
                    console.log(err);
					layer.msg('出错啦');
				});
            },
            // 日期
			initDate: function() {
                const _this = this

                $(_this.$refs.salon_acd_main).daterangepicker({
                    parentEl: '.salon-acd-wrap',
                    singleDatePicker: true,
                    // drops: 'up',
                    timePicker: true,
                    timePickerIncrement: 1,
                    timePicker12Hour: false,
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                }, function(start, end, label) {
                    event.preventDefault()
                    _this.salon_edit_form.activity_date = start.format('YYYY-MM-DD HH:mm')
                })

                $(_this.$refs.salon_usedate_main).daterangepicker({
                    parentEl: '.salon-usedate-wrap',
                    // drops: 'up',
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                }, function(start, end, label) {
                    event.preventDefault()
                    _this.salon_usedate_start = start.format('YYYY-MM-DD')
                    _this.salon_usedate_end = end.format('YYYY-MM-DD')
                    _this.salon_usedate_txt = _this.salon_usedate_start + ' ~ ' + _this.salon_usedate_end
                })
			},



            // 列表
			getSalonTable: function(page) {
				const _this = this;

				_this.loading = true;
				Vue.axios.post('VipShareholder/getSalonActivityList', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": page,
                            "page_size": _this.GLOBAL.PAGESIZE,
                            "shop_id": _this.salon_list_form.shop_id,
                            "status": _this.salon_list_form.status
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
                            _this.salon_total = Number(res.data.response.result.count)
                            _this.salon_page = 1
						}
						_this.salon_table = res.data.response.result.data;
						_this.loading = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
            },
            // 删除
			salonDel(row) {
				const _this = this;

				layer.confirm('删除后不可恢复，确定删除吗？', {
					btn: ['确定', '取消']
				}, function() {
					Vue.axios.post('VipShareholder/delSalonActivity', {
						"header": Vue.request_header,
						"request": {
							"version": Vue.version,
							"param": {
                                "id": row.id,
                                "shop_id": row.shop_id
							}
						},
						"comment": ""
					})
					.then(res => {
						if(res.data.response.result_code == "true") {
							layer.msg('删除成功');
							_this.getSalonTable(_this.salon_page);
						} else {
							Vue.timeoutfun(res.data.response.result_status, _this);
							layer.msg(res.data.response.error_msg);
						}
					})
					.catch(err => {
						layer.msg('出错啦');
					});
				});
            },
            // 报名详情
            salonRank(row) {
                this.salon_rank_form = {
                    name: row.name,
                    user_num: row.user_num,
                    shop_id: row.shop_id,
                    activity_id: row.id
                }
                this.getSalonRank(1)
                this.showList = false
                this.showRank = true
            },
            getSalonRank(page) {
                const _this = this

				_this.loading = true
				Vue.axios.post('VipShareholder/getSalonActivityUserInfo', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": page,
                            "page_size": _this.GLOBAL.PAGESIZE,
                            "shop_id": _this.salon_rank_form.shop_id,
                            "activity_id": _this.salon_rank_form.activity_id
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
                            _this.rank_total = Number(res.data.response.result.count)
                            _this.rank_page = 1
						}
						_this.rank_table = res.data.response.result.data
						_this.loading = false
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this)
						layer.msg(res.data.response.error_msg)
					}
				})
				.catch(err => {
					layer.msg("出错啦")
				})
            },
            // 点击新增
			salonAdd() {
                this.salon_edit_id = ''
                this.salon_edit_tit = '新增活动'
                this.salon_edit_form = {
                    shop_id: this.shop_list[0].id,
                    name: '',
                    activity_date: '',
                    home_page_img: require('../../assets/images/upload_btn.png'),
                    home_page_img_done: false,
                    detail_imgs: []
                }
                this.salon_usedate_txt = ''
				this.salon_usedate_start = ''
                this.salon_usedate_end = ''
				this.uploader_list = []
                this.showList = false
                this.showEdit = true
			},
			// 点击修改
			salonModify(row) {
                this.salon_edit_id = row.id
                this.salon_edit_tit = '修改活动'
                this.salon_edit_form = {
                    shop_id: row.shop_id,
                    name: row.name,
                    activity_date: row.activity_date,
                    home_page_img: row.home_page_img,
                    home_page_img_done: true,
                    detail_imgs: []
                }
				this.salon_usedate_start = row.sign_up_start_time
                this.salon_usedate_end = row.sign_up_end_time
                this.salon_usedate_txt = row.sign_up_start_time + '~' + row.sign_up_end_time
                row.detail_imgs.forEach((item, k) => {
					this.salon_edit_form.detail_imgs.push({
                        id: 'isfiles' + k,
                        src: item,
                        done: true
                    })
					this.salonImgUpload('isfiles' + k, k)
				})
                this.showList = false
                this.showEdit = true
            },
            // 活动首页图片
			salonCoverUpload: function() {
				let _this = this;
				let host = '',
					dir = '',
					file_name = '';

				setTimeout(function() {
					// 实例化一个plupload上传对象
					let uploader = new plupload.Uploader({
						browse_button: 'salonCover', // 选择文件id
						filters: {
							mime_types: [ // 文件格式限制
								{ title: "Image files", extensions: "jpg,jpeg,png,gif" }
							],
							// max_file_size: '2mb', // 文件大小限制
							// prevent_duplicates: true // 不允许选取重复文件
						},
						// resize: {
						// 	width: 527,
						// 	height: 296
						// },
						multi_selection: false, // 单选
						url: './', // OSS地址
						init: {
							// 文件上传前触发
							BeforeUpload: function(up, file) {},
							// 文件选择完毕触发
							FilesAdded: function(up, files) {
								// 获取签名
								Vue.axios.post('publicData/api_getOssSignature', {
									"header": Vue.request_header,
									"request": {
										"version": Vue.version,
										"param": {
											"file": files[0].name,
											"path": 'system_set'
										}
									},
									"comment": ""
								})
								.then(res => {
									if(res.data.response.result_code == "true") {
										host = res.data.response.data.host;
										dir = res.data.response.data.dir;
										file_name = res.data.response.data.file_name;
										const new_params = {
											'key': dir + file_name,
											'OSSAccessKeyId': res.data.response.data.accessid,
											'policy': res.data.response.data.policy,
											'signature': res.data.response.data.signature,
											'success_action_status': '200', // 让服务端返回200，不然，默认会返回204
										};
										up.setOption({
											'url': host,
											'multipart_params': new_params
										});

										// 上传文件
										uploader.start();
									} else {
										Vue.timeoutfun(data.response.result_status, _this);
										layer.msg(data.response.error_msg);
									}
								})
								.catch(err => {
									layer.msg("出错啦");
								});
							},
							// 文件上传成功触发
							FileUploaded: function(up, file, data) {
                                _this.salon_edit_form.home_page_img = host + "/" + dir + file_name
                                _this.salon_edit_form.home_page_img_done = true
							},
							// 错误提示
							Error: function(up, err) {
								if(err.code == -600) {
									layer.msg('请选择2mb以内的文件');
								} else if (err.code == -601) {
									layer.msg('只允许上传jpg,jpeg,png,gif文件');
								} else if (err.code == -602) {
									layer.msg('这个文件已经上传过一遍了');
								} else {
									layer.msg(err.response);
								}
							}
						}
					});
					// 初始化
					uploader.init();
				}, 20);
            },
            // 新增图片
            salonImgsAdd: function() {
                const index = this.salon_edit_form.detail_imgs.length
                const id = 'isfiles' + index
                this.salon_edit_form.detail_imgs.push({
                    id: id,
                    src: require('../../assets/images/scrn_img_hp.png'),
                    done: false
                })
				this.salonImgUpload(id, index)
            },
            // 删除图片
            salonImgsDel: function(index) {
                const arr = [...this.salon_edit_form.detail_imgs]
                arr.splice(index, 1)
                this.salon_edit_form.detail_imgs = []
                this.uploader_list = []
				this.$nextTick(() => {
                    arr.forEach((v, k) => {
                        this.salon_edit_form.detail_imgs.push({
                            id: 'isflies' + k,
                            src: v.src,
                            done: v.done
                        })
                        this.salonImgUpload('isflies' + k, k);
                    })
				})
			},
			// 上传图片
			salonImgUpload: function(id, index) {
				let _this = this;
				let host = '',
					dir = '',
					file_name = '';

                if(_this.uploader_list.includes(id)) {
					return false
				} else {
					_this.uploader_list.push(id)
				}
				setTimeout(function() {
					// 实例化一个plupload上传对象
					let uploader = new plupload.Uploader({
						browse_button: id, // 选择文件id
						filters: {
							mime_types: [ // 文件格式限制
								{ title: "Image files", extensions: "jpg,jpeg,png,gif" }
							],
							// max_file_size: '2mb', // 文件大小限制
							prevent_duplicates: true // 不允许选取重复文件
						},
						// resize: {
						// 	width: 527,
						// 	height: 296
						// },
						multi_selection: false, // 单选
						url: './', // OSS地址
						init: {
							// 文件上传前触发
							BeforeUpload: function(up, file) {},
							// 文件选择完毕触发
							FilesAdded: function(up, files) {
								// 获取签名
								Vue.axios.post('publicData/api_getOssSignature', {
									"header": Vue.request_header,
									"request": {
										"version": Vue.version,
										"param": {
											"file": files[0].name,
											"path": 'system_set'
										}
									},
									"comment": ""
								})
								.then(res => {
									if(res.data.response.result_code == "true") {
										host = res.data.response.data.host;
										dir = res.data.response.data.dir;
										file_name = res.data.response.data.file_name;
										const new_params = {
											'key': dir + file_name,
											'OSSAccessKeyId': res.data.response.data.accessid,
											'policy': res.data.response.data.policy,
											'signature': res.data.response.data.signature,
											'success_action_status': '200', // 让服务端返回200，不然，默认会返回204
										};
										up.setOption({
											'url': host,
											'multipart_params': new_params
										});

										// 上传文件
										uploader.start();
									} else {
										Vue.timeoutfun(data.response.result_status, _this);
										layer.msg(data.response.error_msg);
									}
								})
								.catch(err => {
									layer.msg("出错啦");
								});
							},
							// 文件上传成功触发
							FileUploaded: function(up, file, data) {
								_this.salon_edit_form.detail_imgs[index].src = host + "/" + dir + file_name
								_this.salon_edit_form.detail_imgs[index].done = true
								layer.msg('上传成功')
							},
							// 错误提示
							Error: function(up, err) {
								if(err.code == -600) {
									layer.msg('请选择2mb以内的文件');
								} else if (err.code == -601) {
									layer.msg('只允许上传jpg,jpeg,png,gif文件');
								} else if (err.code == -602) {
									layer.msg('这个文件已经上传过一遍了');
								} else {
									layer.msg(err.response);
								}
							}
						}
					});
					// 初始化
					uploader.init();
				}, 20);
            },
            // 新增、修改
			salonEdit() {
                const _this = this;

                if(!_this.salon_edit_form.home_page_img_done) {
                    layer.msg('请上传活动首页')
                    return false
                }
                let detail_imgs = [];
				_this.salon_edit_form.detail_imgs.forEach(v => {
					if(v.done) {
						detail_imgs.push(v.src);
					}
				})
                let data = {
                    "header": Vue.request_header,
					"request": {
						"param": {
                            "shop_id": _this.salon_edit_form.shop_id,
                            "name": _this.salon_edit_form.name,
                            "activity_date": _this.salon_edit_form.activity_date,
                            "sign_up_start_time": _this.salon_usedate_start,
                            "sign_up_end_time": _this.salon_usedate_end,
                            "home_page_img": _this.salon_edit_form.home_page_img,
                            "detail_imgs": detail_imgs
						}
					},
					"comment": ""
                };
                if(_this.salon_edit_id) {
                    data.request.param.id = _this.salon_edit_id;
                }
                Vue.axios({
					method: 'post',
					url: 'VipShareholder/editSalonActivity',
					data: data
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						layer.msg('操作成功')
						_this.getSalonTable(_this.salon_page)
						_this.showList = true
						_this.showEdit = false
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
            },
            // 返回
            salonBack() {
                this.showList = true
                this.showEdit = false
                this.showRank = false
            },
        }
    }
</script>
<style lang="less" scoped>
    .salon-edit {
		.el-form {
            .el-select {
                width: 400px;
            }
            .el-input {
                width: 400px;
            }
            .salon-acd-wrap {
                position: relative;
                width: 530px;
            }
            .salon-usedate-wrap {
                position: relative;
            }
            .salon-cover {
                float: left;
                width: 114px;
                height: 114px;
                cursor: pointer;
            }
            li {
                position: relative;
                float: left;
                width: 180px;
                height: 101px;
                margin: 0 30px 30px 0;
                .salon-imgs-del {
                    position: absolute;
                    right: -11px;
                    top: -11px;
                    cursor: pointer;
                    z-index: 1999;
                }
                .salon-imgs-item {
                    display: block;
                    width: 180px;
                    height: 101px;
                    cursor: pointer;
                }
                .salon-imgs-add {
                    cursor: pointer;
                }
            }
		}
    }
</style>